import { render, staticRenderFns } from "./SamTextarea.vue?vue&type=template&id=297ce4ba&scoped=true&shadow"
import script from "./SamTextarea.vue?vue&type=script&lang=js&shadow"
export * from "./SamTextarea.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamTextarea.vue?vue&type=style&index=0&id=297ce4ba&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "297ce4ba",
  null
  ,true
)

export default component.exports